module.exports = new __parcel__URL__("image-product-1.4f5deaf7.jpg").toString();